/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.formatter.di

import org.koin.dsl.module
import studio.oddpods.cauce.core.datastore.UserPreferencesRepository
import studio.oddpods.cauce.core.formatter.CurrencyFormatter
import studio.oddpods.cauce.core.formatter.DateFormatter
import studio.oddpods.cauce.core.formatter.RenderMessageTemplateUseCase

val FormatterModule = module {
    single { CurrencyFormatter(prefs = get<UserPreferencesRepository>().userData) }
    single { DateFormatter(prefs = get<UserPreferencesRepository>().userData) }
    single { RenderMessageTemplateUseCase(currencyFormatter = get(), dateFormatter = get()) }
}
